import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-akademie',
  templateUrl: './akademie.component.html',
  styleUrls: ['./akademie.component.scss']
})
export class AkademieComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
